module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsYearly.283b3f2.webp";